import { html } from "lit";
import { u } from "@converse/headless";

/**
 * Appends a media-fragment time offset so the browser paints a real frame as
 * the poster. With `preload="metadata"` alone most browsers (Chromium included)
 * show a black rectangle until Play is pressed; `#t=0.1` makes them seek to and
 * display frame 0.1s in, which is the preview. Only added to plain http(s) and
 * blob: URLs that don't already carry a fragment.
 * @param {string} url
 * @returns {string}
 */
function withPosterFragment(url) {
    if (!url || url.includes("#")) return url;
    return /^(blob:|https?:)/i.test(url) ? `${url}#t=0.1` : url;
}

/**
 * The browser cannot decode this file (typically an HEVC/H.265 .mov from a newer
 * iPhone, or an .mkv): the <video> would sit there as an empty black box with no
 * hint. Replace it with a readable notice and a download link so the file is
 * still reachable.
 * @param {Event} ev
 */
function onVideoError(ev) {
    const video = /** @type {HTMLVideoElement} */ (ev.target);
    const src = (video.currentSrc || video.src || "").replace(/#.*$/, "");
    const note = document.createElement("div");
    note.className = "chat-video__unsupported";
    note.textContent = "Відео не підтримується для перегляду в цьому застосунку. ";
    if (src) {
        const link = document.createElement("a");
        link.href = src;
        link.download = "";
        link.textContent = "Завантажити";
        note.appendChild(link);
    }
    video.replaceWith(note);
}

/**
 * @param {string} url
 * @param {boolean} [hide_url]
 */
export default (url, hide_url) => {
    const { hostname } = u.getURL(url);
    return html`<figure class="chat-video"><video controls playsinline preload="metadata" src="${withPosterFragment(url)}" @error="${onVideoError}"></video>${hide_url || !hostname
            ? ""
            : html`<a target="_blank" rel="noopener" title="${url}" href="${url}">${hostname}</a>`}</figure>`;
};
